import { render, staticRenderFns } from "./EditStatusReasonForm.vue?vue&type=template&id=3c028a58&scoped=true&"
import script from "./EditStatusReasonForm.vue?vue&type=script&lang=ts&"
export * from "./EditStatusReasonForm.vue?vue&type=script&lang=ts&"
import style0 from "./EditStatusReasonForm.vue?vue&type=style&index=0&id=3c028a58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c028a58",
  null
  
)

export default component.exports